// GLOBAL-NAV-1 — keep-alive outlet. Renders EVERY alive location; the active one
// is shown, the rest are display:none (NOT unmounted), so a page keeps all its
// state (filters, sort, scroll, loaded data) when you navigate away and Back.
// Page components are rendered by `render(loc)` exactly as before — unchanged.
//
// The active wrapper MUST be a transparent flex-column that fills `.main`
// (which is `display:flex;flex-direction:column;overflow:hidden`). Page roots
// (`.page`, `.workbench-page`) rely on being a `flex:1;min-height:0` child to
// own the scroll (`.page{overflow-y:auto}`). Without these wrapper styles the
// page expands past the viewport and `.main`'s overflow:hidden clips it with no
// scrollbar — i.e. the whole app stops scrolling. (Fixed 2026-06-09.)
const ACTIVE_STYLE = { flex: "1 1 auto", minHeight: 0, display: "flex", flexDirection: "column" };
const HIDDEN_STYLE = { display: "none" };

export default function KeepAliveOutlet({ alive, currentKey, render }) {
  return (
    <>
      {alive.map((loc) => (
        <div key={loc.key} data-navkey={loc.key}
             style={loc.key === currentKey ? ACTIVE_STYLE : HIDDEN_STYLE}>
          {render(loc)}
        </div>
      ))}
    </>
  );
}
